<template>
  <div class="btn_export">
    <BaseButton :type="'primary'" @click="handleClick('import')" v-if="isImport">
      <Icon icon="uil:export" />
      导入</BaseButton
    >
    <BaseButton @click="handleClick('export')" :loading="expLoading" v-if="isExport">
      <Icon icon="uil:import" />
      导出</BaseButton
    >
    <ElDrawer v-model="drawerVisible" title="导入文件" size="small" :close-on-click-modal="false">
      <div class="import_tips">
        <span>选择EXCEL文件，请确保数据结构一致。 </span>
        <BaseButton link type="primary" @click="dowTemClick('dowTem')">下载EXCEL模板</BaseButton>
      </div>
      <div>
        <ElUpload
          v-model:file-list="fileList"
          class="upload-demo"
          action="#"
          :http-request="handleHttpRequest"
          :before-upload="beforeUpload"
          :multiple="false"
          :show-file-list="false"
        >
          <BaseButton type="primary" :loading="uploading"
            ><Icon icon="uil:export" />上传</BaseButton
          >
          <template #tip>
            <!-- <div class="el-upload__tip"> jpg/png files with a size less than 500KB. </div> -->
          </template>
        </ElUpload>
      </div>
      <template #footer>
        <div class="drawer-footer">
          <el-button @click="drawerVisible = false">关闭</el-button>
        </div>
      </template>
    </ElDrawer>
  </div>
</template>

<script setup lang="ts">
import { ElMessage, ElDrawer, ElUpload } from 'element-plus'
import { ref } from 'vue'
import { Dialog } from '/@/components/Dialog'
import { BaseButton } from '@/components/Button'

const props = defineProps({
  // 导出按钮加载中
  expLoading: {
    type: Boolean,
    default: false
  },
  // 导入按钮是否显示
  isImport: {
    type: Boolean,
    default: true
  },
  // 导出按钮是否显示
  isExport: {
    type: Boolean,
    default: true
  },
  // 上传中
  uploading: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['export', 'import', 'dowTem'])
const nowType = ref('import')

const handleHttpRequest = (data) => {
  // emit('import', data.file)
}
// 点击按钮打开弹窗或执行导出
const handleClick = (type) => {
  nowType.value = type
  if (type === 'export') {
    emit('export')
  } else if (type === 'import') {
    drawerVisible.value = true
  }
}

// 下载模板
const dowTemClick = (type) => {
  emit('dowTem', type)
}

// 上传
const beforeUpload = async (file) => {
  // 只能上传 excel 文件
  const isExcel =
    file.type === 'application/vnd.ms-excel' ||
    file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  if (!isExcel) {
    ElMessage.error('上传文件只能是 excel 文件')
    return false
  }
  console.log('上柴那文件')
  emit('import', file)
  return true
}

const drawerVisible = ref(false)
const fileList = ref([])
</script>

<style scoped lang="less">
::v-deep .el-drawer__header {
  margin-bottom: 0;
}

.import_tips {
  margin-bottom: 10px;
}

.btn_export {
  margin-right: 10px;
  margin-left: 10px;
}
</style>
